import { ApartmentsContainer } from '../../containers/advancedFilters/ApartmentsContainer';
import { IFilter } from '../../types/filters';

export const apartments: IFilter = {
  component: ApartmentsContainer,
};
